import {
    deserializationPolicy,
    exponentialRetryPolicy,
    redirectPolicy,
    systemErrorRetryPolicy,
} from '@azure/ms-rest-js';
import type { ApiModels } from '@ori/global-api-client';
import { Api } from '@ori/global-api-client';

import type { NotifyMePopupConfig } from '../models';
import { authorizationPolicy } from './policies/AuthorizationPolicy';
import { tenantPolicy } from './policies/TenantPolicy';

type InnerAppConfig = Omit<NotifyMePopupConfig, 'translations'>;

class ClientProvider {
    private clientInternal: Api | undefined;
    private appConfig?: InnerAppConfig;

    init(appConfig: InnerAppConfig) {
        this.appConfig = appConfig;
    }

    private create(): Api {
        if (!this.appConfig) {
            throw new Error('[back-in-stock-notification]: ClientProvider was not initialized!');
        }

        const options: ApiModels.ApiOptions = {
            baseUri: this.appConfig.globalApiUrl,

            requestPolicyFactories: [
                authorizationPolicy(),
                tenantPolicy(this.appConfig.tenant),
                deserializationPolicy(),
                redirectPolicy(),
                exponentialRetryPolicy(),
                systemErrorRetryPolicy(),
            ],
        };

        return new Api(options);
    }

    get client(): Api {
        if (!this.clientInternal) {
            this.clientInternal = this.create();
        }

        return this.clientInternal;
    }
}

export const clientProvider = new ClientProvider();

export const getApiClient = (): Api => clientProvider.client;
